export default __webpack_public_path__ + "static/media/large.c4a51c02.jpg";